<template>
  <div>
    <right-panel  :datas="safeObj" @onClose="onClose()" ref="safe-apply-modal" :hideFooter="safeObj && safeObj.isHideFooter">
      <div slot="header" v-if="safeObj">
        <div v-if="safeObj.viewType==='my'"><translate>The Details Of My Application</translate></div>
        <div v-if="safeObj.viewType!=='my'"><translate>Show The Details Of The Application</translate></div>
      </div>
      <div slot="content">
        <div class="mySqlDatail" v-if="safeObj">
          <el-row type="flex" justify="center" v-if="safeObj.viewType==='my' && (safeObj.app_status=== 1 || safeObj.app_status=== 2)">
            <el-col :span="10" class="view-right"><translate>Approver</translate><span>:</span></el-col>
            <el-col :span="10" v-if="safeObj.approver_id">{{safeObj.approver.name}}({{safeObj.approver.account}})</el-col>
            <el-col :span="10" v-if="safeObj.reject_id">{{safeObj.reject.name}}({{safeObj.reject.account}})</el-col>
          </el-row>
          <el-row type="flex" justify="center" v-if="safeObj.viewType==='approve'">
            <el-col :span="10" class="view-right"><translate>Applyer</translate><span>:</span></el-col>
            <el-col :span="10" >{{safeObj.account.name}}({{safeObj.account.account}})</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>Resource</translate><span>:</span></el-col>
            <el-col :span="10">{{safeObj.resource.name}}({{safeObj.resource.ip_address}})</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>Project</translate> <span>:</span></el-col>
            <el-col :span="10" v-if="safeObj.project">{{safeObj.project.project_name}}</el-col>
            <el-col :span="10" v-if="!safeObj.project">-</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>Status</translate><span>:</span></el-col>
            <el-col :span="10">{{(safeApplyStatusText[safeObj.app_status] || safeObj.app_status)}}</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>Create Time</translate><span>:</span></el-col>
            <el-col :span="10">{{safeObj.create_time  * 1000 | moment('YYYY-MM-DD HH:mm:ss')}}</el-col>
          </el-row>
          <el-row type="flex" justify="center" v-if="safeObj.app_status === 1 || safeObj.app_status ===2">
            <el-col :span="10" class="view-right"><translate>Update Time</translate><span>:</span></el-col>
            <el-col :span="10">{{safeObj.update_time  * 1000 | moment('YYYY-MM-DD HH:mm:ss')}}</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>The reason for the application</translate><span>:</span></el-col>
            <el-col :span="10">{{safeObj.reason}}</el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="10" class="view-right"><translate>Non-security mode expiration time</translate><span>:</span></el-col>
            <el-col :span="10">{{safeObj.expire_time * 1000 | moment('YYYY-MM-DD HH:mm:ss')}}</el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" class="detail-btn" v-if="safeObj">
        <el-button v-if="safeObj.viewType==='my' && safeObj.app_status===0 " v-loading="cancelLoading" type="primary" @click="cancelSafeApply(safeObj.id)">
          <translate>Cancel the application</translate>
        </el-button>
        <el-button v-if="safeObj.viewType==='approve' && safeObj.app_status=== 0 " v-loading="passLoading" type="primary" @click="doExecute(safeObj.id)">
          <translate>Pass</translate>
        </el-button>
        <el-button v-if="safeObj.viewType==='approve' && safeObj.app_status=== 0 " v-loading="rejectLoading" type="primary" @click="doReject(safeObj.id)">
          <translate>Reject</translate>
        </el-button>
      </div>
    </right-panel>
  </div>
</template>
<script>
import STORE_CONST from '../../../store/consts.js'
import RightPanel from '../../common/right-panel'
export default {
  name: 'safeView',
  props: {
    items: {
      required: true
    }
  },
  data () {
    return {
      safeObj: null,
      type: '',
      isHideFooter: false,
      cancelLoading: false,
      passLoading: false,
      rejectLoading: false,
      safeApplyStatusText: {
        0: this.$gettext('approving'),
        1: this.$gettext('approved'),
        2: this.$gettext('rejected'),
        3: this.$gettext('failed')
      }
    }
  },
  methods: {
    onClose () {
      this.safeObj = null
      this.$emit('onClosePanel')
    },
    cancelSafeApply (id) {
      this.cancelLoading = true
      this.$confirm(
        this.$gettext('Are you sure you want to cancel non-security mode application?'),
        this.$gettext('Please confirm?'),
        {
          confirmButtonText: this.$gettext('OK'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(STORE_CONST.REVIEW.DELETE_SAFE_APPLY, id).then((res) => {
            this.cancelLoading = false
            this.$notify({
              type: 'success',
              message: this.$gettext('Cancel successfully!')
            })
            this.$emit('viewCallback')
            this.$emit('onClosePanel')
          }, () => {
            this.cancelLoading = false
          })
        })
    },
    doExecute (id) {
      this.passLoading = true
      this.$confirm(
        this.$gettext('Through current non-security mode application?'),
        this.$gettext('Through non-security mode application'),
        {
          confirmButtonText: this.$gettext('OK'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(STORE_CONST.REVIEW.DO_SAFE_EXCUTE, id).then((res) => {
            this.passLoading = false
            this.$notify({
              type: 'success',
              message: this.$gettext('Submit success, you can check result later.')
            })
            this.$emit('viewCallback')
            this.$emit('onClosePanel')
          }, () => {
            this.passLoading = false
          })
        })
    },
    doReject (id) {
      console.log('doreject')
      this.rejectLoading = true
      this.$confirm(
        this.$gettext('Reject the current non-security mode application?'),
        this.$gettext('Reject non-safe mode application'),
        {
          confirmButtonText: this.$gettext('OK'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(STORE_CONST.REVIEW.DO_SAFE_REJECT, id).then((res) => {
            this.rejectLoading = false
            this.$emit('viewCallback')
            this.$emit('onClosePanel')
          }, () => {
            this.rejectLoading = false
          })
        })
    }
  },
  watch: {
    'items': {
      handler: function (newVal) {
        console.log('newVal', newVal)
        if (this.safeObj) {
          this.safeObj = null
          setTimeout(() => {
            console.log('items', this.items)
            this.safeObj = this.items
            this.isHideFooter = newVal.isHideFooter
          }, 300)
        } else {
          this.safeObj = this.items
          this.isHideFooter = newVal.isHideFooter
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel
  }
}
</script>
<style lang='scss' rel="stylesheet/scss">
.mySqlDatail{
  .el-row{
    padding-top:10px;
    padding-bottom:10px;
  }
}
.view-right{
  text-align: right;
  padding-right:30px;
}
</style>



// WEBPACK FOOTER //
// safeView.vue?61f215c3